import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../static/landing/Logo.svg';
import '../../styles/LandingFooter.css';

export default function LandingFooter() {
    const location = useLocation();
    const noFooter = ["/login", "/register", "/resetpassword", "/newpassword", "/passwordsaved"];

    return (
        <footer className="LandingFooter">
            {
                !noFooter.find(path => path === location.pathname) &&
                <>
                <div className="LandingFooter-Left">
                <Link 
                to="/" 
                className="LandingFooter-Logo">
                    <img 
                    src={Logo} 
                    alt="Salewave Logo" />
                </Link>
                <span className="mobile-none">© 2020 Netrealm</span>
                </div>
                <ul className="LandingFooter-Tabs">
                    <li className="mobile-none">
                        <Link to={{
                        pathname: "/",
                        state: {
                            goToFeatures: true
                        }}}>Features</Link>
                    </li>
                    <li className="mobile-none"><Link to="/pricing">Pricing</Link></li>
                    <li className="mobile-none"><Link to="/faq">FAQ</Link></li>
                    <li><Link to="/terms">Terms</Link></li>
                    <li><Link>Privacy</Link></li>
                    <li><Link>Support</Link></li>
                </ul>
                </>
            }

        </footer>
    )
}